import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { List } from 'immutable'
import messages from 'routes/App/Apps/DataBrowser/translate'
import SelectList from 'components/common/SelectList'
import { fetchLocusList, setActiveLocus } from 'reducers/dataBrowser/reducer'
import Psfs from 'lib/psfs/Psfs'

class LocusFilter extends Component {
  onLocusChange = value => {
    const { activeLocus } = this.props

    if (value && activeLocus !== value.index) {
      this.props.setActiveLocus(value.index)
    }
  }

  shouldComponentUpdate(nextProps) {
    const { activeLocusGroup } = nextProps

    if (this.props.activeLocusGroup !== nextProps.activeLocusGroup) {
      const psfs = new Psfs()

      if (activeLocusGroup !== 0) {
        psfs
          .addFields(['id', 'containerName'])
          .addFilter('locusGroup', activeLocusGroup)
      }

      this.props.fetchLocusList({ psfs })
      this.props.setActiveLocus(0)

      return false
    }

    return true
  }

  render() {
    const {
      activeLocusGroup,
      activeLocus,
      intl: { formatMessage },
    } = this.props
    const locusList = List(
      [{ id: 0, containerName: formatMessage(messages.allLocuses) }].concat(
        this.props.locusList.toArray(),
      ),
    )

    return (
      <SelectList
        variant="outlined"
        name="locus"
        label={formatMessage(messages.units)}
        disabled={Boolean(activeLocusGroup === 0)}
        onChange={this.onLocusChange}
        list={locusList}
        value={activeLocus}
        map={{
          index: 'id',
          text: 'containerName',
        }}
      />
    )
  }
}

export default connect(
  state => ({
    activeLocusGroup: state.getIn(['dataBrowser', 'activeLocusGroup']),
    locusList: state.getIn(['dataBrowser', 'locusList']),
    activeLocus: state.getIn(['dataBrowser', 'activeLocus']),
  }),
  {
    fetchLocusList,
    setActiveLocus,
  },
)(injectIntl(LocusFilter))
